import styled from 'styled-components';

export const Iframe = styled.iframe`
  height: 70vh;
`;